import { render, staticRenderFns } from "./LargeCard.vue?vue&type=template&id=81d145ec"
import script from "./LargeCard.vue?vue&type=script&lang=js"
export * from "./LargeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports